module.exports = __webpack_public_path__ + "static/media/postcard9thumb.def85555.jpg";